import { styled } from "baseui";

export const Text = styled("p", ({ $theme }) => ({
  ...$theme.typography.body,
  color: $theme.colors.contentPrimary,
}));
